export default "__VITE_ASSET__HySg3swQ__"